<lvr-nav-carousel [backLink]="backLink()" [carouselElements]="carouselElements()" [showCarousel]="false">
</lvr-nav-carousel>

<lvr-heading
	(editClicked)="openEdit()"
	[showEditButton]="assignment()?.phaseId === 6 && !isSubmitView() && canEditAssignment()"
>
	<span class="title">
		{{ 'assignment.fds.details_title' | transloco }}
	</span>

	<div [matTooltip]="'assignment.details.send_mail_tooltip' | transloco" ngProjectAs="button-content">
		<lvr-button
			variant="primary"
			[label]="'base.button.send' | transloco"
			[ariaLabel]="'assignment.details.send_mail_tooltip' | transloco"
			[type]="'button'"
			(clicked)="openMail('')"
			icon="forward_to_inbox"
		></lvr-button>
	</div>

	<div ngProjectAs="button-content">
		@if (canSOSReset()) {
			<lvr-button
				variant="primary"
				[label]="'assignment.fds.reset_confirm' | transloco"
				[type]="'button'"
				(clicked)="setReset()"
				icon=""
			></lvr-button>
		}
	</div>
</lvr-heading>

@let entity = assignment();
@if (entity) {
	<table>
		<tr>
			<th scope="col">{{ 'assignment.create_fds.dateOfCommission' | transloco }}:</th>
			<th scope="col">{{ 'base.field.sponsor' | transloco }}:</th>
		</tr>
		<tr>
			<td>{{ entity.careStartDate ? (entity.careStartDate | date: 'dd.MM.yyyy') : '-' }}</td>
			<td>{{ entity.sponsor?.name ?? '-' }}</td>
		</tr>
		<tr>
			<th scope="col">{{ 'base.field.legal_foundation' | transloco }}:</th>
			<th scope="col">{{ 'base.field.type_of_disability_relevant_to_care' | transloco }}:</th>
		</tr>
		<tr>
			<td>{{ entity.legalFoundation?.description ?? '-' }}</td>
			<td>{{ entity.careRelatedHandicap?.disabilityType?.remark ?? '-' }}</td>
		</tr>
		<tr>
			<th scope="col">{{ 'assignment.details.social_data_protection_info' | transloco }}:</th>
			@if (canReadAssignmentDocuments()) {
				<th scope="col">{{ 'base.field.documents' | transloco }}:</th>
			}
		</tr>

		<tr>
			<td>
				{{
					(entity.hasBeenClarified || entity.socialDataProtectionInfo
						? 'assignment.details.social_data_protection_info_yes'
						: 'assignment.details.social_data_protection_info_no'
					) | transloco
				}}<br />
				{{ entity.clarifiedAt | date: dateDisplayFormat }}<br />
				{{ getClarificationLabel(entity.typeOfClarification) | transloco }}
			</td>
			@if (canReadAssignmentDocuments()) {
				<td>
					<ul>
						@for (doc of entity.documents; track doc.id) {
							<li>
								<lvr-document-item [document]="buildDocumentEntryFromFdsAssignment(doc)" (open)="onFileClick(doc)">
								</lvr-document-item>
							</li>
						}
					</ul>
				</td>
			}
		</tr>
		@let cancellationDate = assignment()?.cancellationDate;
		@if (isSubmitView() || cancellationDate) {
			<tr>
				<th scope="col">
					{{
						(shouldShowFp5CancellationDateTitle() ? 'assignment.phase.date5' : 'assignment.details.submitDate')
							| transloco
					}}
				</th>
			</tr>
			<tr>
				<td>{{ cancellationDate ?? currentDatum() | date: 'dd.MM.yyyy' }}</td>
			</tr>
		}
		<tr>
			<th>{{ 'assignment.details.impediment_due_date' | transloco }}</th>
			<th>{{ 'user.assignment_transfer.assignment_number' | transloco }}:</th>
		</tr>
		<tr>
			<td>
				{{ assignment()?.impedimentReportDueDate ? (assignment()?.impedimentReportDueDate | date: 'dd.MM.yyyy') : '-' }}
			</td>
			<td>{{ entity.guid }}</td>
		</tr>
	</table>
}

@if (!isSubmitView()) {
	<div lvrPadding [padHorizontal]="32" [padVertical]="16">
		<h3>{{ 'assignment.fds.template_title' | transloco }}</h3>

		@if (submittedReports().length === 0) {
			<p lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'assignment.details.no_reports' | transloco }}</p>
		} @else {
			<div class="report-list">
				@for (report of submittedReports(); track report.id) {
					<button class="report-row" [disabled]="!canOpenReport()" (click)="openTemplateRoute(report)">
						<span class="report-title-group">
							<b class="report-category">{{ report.categoryReport.description }}</b>
							<div>
								<span class="report-created">{{ 'assignment.details.report_created' | transloco }}:</span>
								<span class="report-date">
									{{ report.createdAt | date: 'dd.MM.yyyy' }}
								</span>
							</div>
						</span>
						<mat-chip class="chip-default">
							@if (report.isFinal) {
								{{ 'assignment.details.finished_report' | transloco }}
							} @else if (!report.isFinal && report.isDraft) {
								{{ 'assignment.details.draft_report' | transloco }}
							} @else if (!report.isFinal && !report.isDraft) {
								{{ 'assignment.details.ready_report' | transloco }}
							}
						</mat-chip>
					</button>
				}
			</div>
		}
	</div>
}
